module.exports = __webpack_public_path__ + "static/media/George-Williams.4aa99815.jpg";